import { all, call, put, takeLatest } from "redux-saga/effects";
import { http } from "../../common/lib";
import config from "../../config";
import { actionCreators, actionTypes } from "./actions";
import { logToSentry } from "../../config/Sentry";

function* get() {
    try {
        const { data } = yield call(
            http.authorized.get,
            config.api.paths.organisations
        );
        yield put(actionCreators.getSuccess(data));
    } catch (error) {
        logToSentry("On organisations get:", { error });
        yield put(actionCreators.getFailure(error));
    }
}

function* patch(action) {
    const { logoAltFile, logoFile, organisation } = action.payload;
    const url = `${config.api.paths.organisations}${organisation.id}/`;
    try {
        if (logoAltFile) {
            const formData = new FormData();
            formData.append("logo_alt_path", logoAltFile, logoAltFile.name);
            yield call(http.authorized.patchForm, url, formData);
        }
        if (logoFile) {
            const formData = new FormData();
            formData.append("logo_path", logoFile, logoFile.name);
            yield call(http.authorized.patchForm, url, formData);
        }
        const { data } = yield call(http.authorized.patch, url, {
            name: organisation.name,
            type: organisation.type
        });
        yield put(actionCreators.patchSuccess(data));
    } catch (error) {
        logToSentry("On organisation patch:", { error });
        yield put(actionCreators.patchFailure(error));
    }
}

export default function* () {
    yield all([
        takeLatest(actionTypes.ORGANISATIONS_GET_REQUEST, get),
        takeLatest(actionTypes.ORGANISATION_PATCH_REQUEST, patch)
    ]);
}
